<template>
    <section>
        <page-header>
            <slot slot="title">{{ $t('global.welcome') }}<slot v-if="fullName.length > 0">, {{ fullName }}</slot></slot>
            <slot slot="description">
                <p>{{ $t('intro.customer_dashboard') }}</p>
            </slot>
            <slot slot="action">
                <router-link v-if="isCustomer || isPersoneel" class="c-button c-button--base" :to="{ name: 'FastOrder' }">
                    {{ $t('dashboard.customer.online_order') }}
                </router-link>
            </slot>
        </page-header>

      <section v-if="isCustomer || isPersoneel" class="o-wrapper o-wrapper--center o-page-row--large">
        <h2 class="c-title--border u-h3">{{ $t('dashboard.customer.shop_brands') }}</h2>
        <div class="u-flex gap">
          <p class="text-shop">{{ $t('dashboard.customer.go_to_shop') }}</p>
          <div class="c-nav--horizontal brand-list">
            <router-link v-for="brand in brands" :key="brand.Code" :to="{ name: 'ShopOverview', query: {Brands: brand.Name} }" class="brand">{{ brand.Name }}</router-link>
          </div>
        </div>
      </section>

        <section class="o-wrapper o-wrapper--center">
            <v-banner class="c-banner--commercial o-page-row--large" location="Dashboard"></v-banner>

            <section class="o-page-row--large">
                <h2 class="c-title--border u-h3">{{ $t('dashboard.customer.new_messages') }}</h2>
                <v-overview-list
                        data-table="Notifications"
                        filter-theme="white"
                        :table-columns="Notifications.columns"
                        :page-size="99"
                        :wrapper="false"
                        prefix="not">
                </v-overview-list>
            </section>

            <section class="o-page-row--large" v-if="isCustomer">
                <h2 class="c-title--border u-h3">{{ $t('dashboard.customer.open_preorders') }}</h2>
                <v-overview-list
                        data-table="PreOrders"
                        btnViewPath="CustomerPreOrdersEdit"
                        filter-theme="white"
                        :table-columns="PreOrders.columns"
                        :btnCopy="false"
                        :page-size="99"
                        :wrapper="false"
                        prefix="opo">
                </v-overview-list>
            </section>

            <!--<section class="o-page-row--large">
                <h2 class="c-title--border u-h3">{{ $t('dashboard.customer.your_brands') }}</h2>
                <div class="c-image-list o-spacing">
                    <img src="@/assets/images/dummy/merk-1.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-2.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-3.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-4.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-5.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-6.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-7.jpg" alt="">
                    <img src="@/assets/images/dummy/merk-8.jpg" alt="">
                </div>
            </section>-->

        </section>
    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VBanner from '@/components/banners/Banner'
    import VOverviewList from '@/components/OverviewList'
    import {config, http} from "../../api/__http";
    import axios from "axios";

    export default {
        props: {},
        components: {
            PageHeader,
            VBanner,
            VOverviewList
        },
        data() {
            return {
                newMessages: {
                    columns: [
                        {value: 'Date', name: 'Datum', sortable: false},
                        {value: 'Title', name: 'Titel', sortable: false},
                        {value: 'Message', name: 'Bericht', sortable: false},
                    ]
                },

              brands: Array
            }
        },
        computed: {
            Notifications() {
                return {
                    columns: [
                        {
                            value: 'Date',
                            name: this.$t('notification_overview.columns.created'),
                            type: 'Date',
                            sortable:false
                        },
                        {
                            value: 'Title',
                            name: this.$t('notification_overview.columns.title'),
                            sortable:false
                        },
                        {
                            value: 'Content',
                            name: this.$t('notification_overview.columns.content'),
                            type: 'Html',
                            sortable:false
                        },
                    ]
                };
            },
            PreOrders() {
                return {
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },
                        { value: 'LastUpdate', name: this.$t('preorder_overview.columns.last_update'), type: 'Date' },
                        { value: 'SalesMan', name: this.$t('preorder_overview.columns.salesman') },
                        { value: 'HasUnReadMessages', name: this.$t('preorder_overview.columns.messages'), type: 'Boolean'},
                        { value: 'CustomerState', name: this.$t('preorder_overview.columns.state') }
                    ]
                };
            },
            fullName() {
                const firstName = this.$store.getters.userInfo.firstName;
                const lastName = this.$store.getters.userInfo.lastName;

                if(firstName && firstName.length > 0 && firstName !== "null") {
                    if(lastName && lastName.length > 0 && lastName !== "null") {
                        return firstName + ' ' + lastName;
                    }

                    return firstName;
                }

                if(lastName && lastName.length > 0 && lastName !== "null"){
                    return lastName;
                }

                return '';
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        },
        methods: {},

      mounted() {
        axios.get(config.baseUrl()+'/brand?filterOnBranch=true').then(response => (this.brands = response.data))
      }
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .gap {
      gap: em($global-spacing-unit-large);
    }

    .text-shop {
      width: 25%;
      color: $color-neutral;
    }

    .brand-list {
      align-content: space-around;
      gap: em($global-spacing-unit-small);
    }

    .brand {
      padding: em($global-spacing-unit-small);
      outline: solid 1px $color-neutral;
      text-decoration: none;
      color: $color-base;
    }

    .brand:hover {
      outline: solid 2px $color-alpha;
      color: $color-alpha;
    }

</style>



// WEBPACK FOOTER //
// src/views/customer/CustomerZone.vue